import { render, staticRenderFns } from "./Zxcy.vue?vue&type=template&id=2d370e93&scoped=true&"
import script from "./Zxcy.vue?vue&type=script&lang=js&"
export * from "./Zxcy.vue?vue&type=script&lang=js&"
import style0 from "./Zxcy.vue?vue&type=style&index=0&id=2d370e93&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d370e93",
  null
  
)

export default component.exports